module.exports = "/_next/static/images/727f9ca9687484a419e4c30cc78cb037-nuconta-inclined-device@1x.png.webp";